import scrollPosition from './scroll-position';

export default function (element) {
    if (element === (element.ownerDocument || {}).body) {
        return scrollPosition(element);
    }

    return {
        x: element.scrollLeft,
        y: element.scrollTop
    };
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/element-scroll-position.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/element-scroll-position.js
// module chunks = 3